import { gql } from '@apollo/client';

export const GET_GUARDIAN_QUERY = gql`
  query GetGuardian($uid: String!) {
    users_by_pk(id: $uid) {
      id
      email
      first_name
      last_name
      full_name
      title
      phone
    }
  }
`;
